<template>
  <v-container>
    <taxStatusCodesUI />
  </v-container>
</template>

<script>
import taxStatusCodesUI from '../../components/shared/taxStatusCodes/taxStatusCodesList.vue';

export default {
  name: 'taxStatusCodes',
  components: {
    taxStatusCodesUI,
  },
};
</script>
